import {mapMutations, mapGetters, mapActions} from "vuex";
import {snakeCase} from 'lodash'
import {required, minLength, email, sameAs} from 'vuelidate/lib/validators'

export default {
    name: "registration",

    data() {
        return {
            isRegister: false,
            submitted: false,
            emailIsBusy: false,
            errors: [],
            payload: {
                name: '',
                email: '',
                password: '',
                passwordConfirmation: ''
            }
        }
    },
    validations: {
        payload: {
            name: {required, minLength: minLength(2)},
            email: {required, email},
            password: {required, minLength: minLength(8)},
            passwordConfirmation: {required, sameAsPassword: sameAs('password')}
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpRegister: 'auth/CHANGE_POPUP_REGISTER',
            changeShowPopUpRegisterSuccess: 'auth/CHANGE_POPUP_REGISTER_SUCCESS'
        }),
        ...mapActions({
            register: 'auth/REGISTRATION'
        }),

        loginUser() {
            this.changeShowPopUpRegister(false)
            this.changeShowPopUpLogin(true)

        },
        registerUser() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.register(this.setData).then(() => {
                    this.changeShowPopUpRegister(false)
                    this.changeShowPopUpRegisterSuccess(true)
                }).catch((error) => {
                    if (error.status === 422) {
                        this.emailIsBusy = true
                    }
                })

            }

        }
    },
    computed: {
        ...
            mapGetters({
                showPopUpLogin: `auth/showPopUpLogin`,
                showPopUpRegisterSuccess: `auth/showPopUpRegisterSuccess`,
                loginData: 'auth/loginData'
            }),
        setData() {
            let payload = {}
            for (let i in this.payload) {
                payload[snakeCase(i)] = this.payload[i]
            }
            return payload
        }
    }
}

